import React from 'react';
import {
  object, string,
} from 'yup';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from '../FormResource.jsx';

const schema = object({
  name: string().required().label('Name'),
  hex: string().uppercase().required().label('Hex')
    .matches(/^#[0-9a-fA-F]{6}$/, 'Invalid Hex Format'),
  pomId: string().required().label('Pom ID'),
  code: string().required().label('Color Code'),
  image: string().label('Image'),
});

const defaults = {
  name: '',
  hex: '',
  pomId: '',
  code: '',
  image: '',
};

const FormColor = ({
  color,
}) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: color,
      api: '/api/core/tfy/colors',
    }}
  >
    <div className="pt-3">
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
      <div className="row">
        <div className="col">
          <FormGroup name='name' label="Name" />
        </div>
        <div className="col">
          <FormGroup name='hex' label="Hex" placeholder='#000000' />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name='pomId' label="Pom Id" />
        </div>
        <div className="col">
          <FormGroup name='code' label="Color Code" />
        </div>
      </div>
      <FormGroup
        name='image'
        as="coverImg"
        api="/api/core/tfy/colors/files"
        label="Image"
      />
    </div>
  </FormResource>
);

export default FormColor;
